module.exports = __webpack_public_path__ + "static/media/videoIcon.5cd8b2d9.png";